var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFwUpgradeErrorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00007 0C8.44382 0 8.85319 0.234375 9.07819 0.61875L15.8282 12.1187C16.0563 12.5062 16.0563 12.9844 15.8344 13.3719C15.6126 13.7594 15.1969 14 14.7501 14H1.25007C0.803192 14 0.387567 13.7594 0.165692 13.3719C-0.0561827 12.9844 -0.0530577 12.5031 0.171942 12.1187L6.92194 0.61875C7.14694 0.234375 7.55632 0 8.00007 0ZM8.00007 4C7.58444 4 7.25007 4.33437 7.25007 4.75V8.25C7.25007 8.66562 7.58444 9 8.00007 9C8.41569 9 8.75007 8.66562 8.75007 8.25V4.75C8.75007 4.33437 8.41569 4 8.00007 4ZM9.00007 11C9.00007 10.7348 8.89471 10.4804 8.70717 10.2929C8.51964 10.1054 8.26528 10 8.00007 10C7.73485 10 7.4805 10.1054 7.29296 10.2929C7.10542 10.4804 7.00007 10.7348 7.00007 11C7.00007 11.2652 7.10542 11.5196 7.29296 11.7071C7.4805 11.8946 7.73485 12 8.00007 12C8.26528 12 8.51964 11.8946 8.70717 11.7071C8.89471 11.5196 9.00007 11.2652 9.00007 11Z",
    fill: "#D75E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFwUpgradeErrorIcon);
export default __webpack_public_path__ + "static/media/FWUpgradeErrorIcon.f2fd9c05ebf273b2b9f578f0aa4b3163.svg";
export { ForwardRef as ReactComponent };